// /resources/js/landing.js

// This file is ONLY for the landing page.
// It imports Alpine and the plugins it needs.

import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import intersect from '@alpinejs/intersect';

window.Alpine = Alpine;

// Register the plugins
Alpine.plugin(collapse);
Alpine.plugin(intersect);

// Start Alpine
Alpine.start();

console.log('[Landing Page] Alpine with plugins initialized.');